import React, { useState, useEffect } from 'react';
import { api } from '../../services/api.js';
import { Link } from 'react-router-dom';
import Navbar from '../navbar/navbar.jsx'
import { vhostV1, vhostV2 } from '../funcoes.js';
import BuscaVazaia from '../components/buscavazia/buscaVazia.jsx';
import customizeScrollbar from "customsb";
import FooterBar from '../footer/footerBar.jsx';
import SRI_pagination from '../components/pagination/pagination.jsx';
import RelAjusteEstoquePDF from '../reports/estoque/relAjusteEstoque.jsx';
import ModalProduto from '../components/modalProduto/ModalProduto.jsx';




function EntradaEstoque() {  


     const [pedidos,setPedidos] = useState([]);
     const [sResult,setSresult] = useState(0);
     const [tipo,setTipo] = useState('T');
     const [dataInical,setDataInicial] = useState(new Date); 
     const [dataFinal,setDataFinal] = useState(new Date);
     const [nPag, setnPag] = useState(1); 
     const [totalPaginas, setTotalPaginas] = useState(0);

      const [dCadastro1,setDcadastro1] = useState(new Date);
          const [dAlteracao1,setDalteracao1] = useState(new Date);
          const [dultCompra1,setDultcompra1] = useState(new Date);
          const [dultVenda1,setDultvenda1] = useState(new Date);
     
          const [usaDcadastro1,setUsaDcadastro1] = useState(false);
          const [usaDAlteracao1,setusaDalteracao1] = useState(false);
          const [usaDultCompra1,setusaDultcompra1] = useState(false);
          const [usaDultVenda1,setusaDultvenda1] = useState(false);
     
          const [dCadastro2,setDcadastro2] = useState(new Date);
          const [dAlteracao2,setDalteracao2] = useState(new Date);
          const [dultCompra2,setDultcompra2] = useState(new Date);
          const [dultVenda2,setDultvenda2] = useState(new Date);
     
          const [usaDcadastro2,setUsaDcadastro2] = useState(false);
          const [usaDAlteracao2,setusaDalteracao2] = useState(false);
          const [usaDultCompra2,setusaDultcompra2] = useState(false);
          const [usaDultVenda2,setusaDultvenda2] = useState(false);
     
          const [colaboradores, setColaboradores] = useState([]);
          const [filtragem, setFiltragem] = useState(false);
          const [dadosRelatorio, setDadosRelatorio] = useState([]);

          const [isProdutoOpen, setIsProdutoOpen] = useState(false);
          const [codProduto, setCodProduto] = useState('');
          const [descricao, setDescricao] = useState('');
           const [vendaDefault,setVendaDefault] = useState(0);
            const [ncm, setNcm] = useState(0);
             const [compra, setCompra] = useState(0);
             const [estoqueAtual,setEstoqueAtual] = useState(0);


           function buscaIten(){
            api.post(vhostV1('webcash/produto/retornaproduto/'+codProduto), {
              loja: localStorage.getItem('loja'),
              empresa: 0         
            },config)
            .then(function (response) { 
              console.log(response);
              
             if(response && response.data && response.data.dados){
              setDescricao(response.data.dados[0].DESCRICAO);
             
               }
             else{
              console.log("Codigo não encontrado");
              
             }  
              
             })
            .catch(function (error) {
             
              console.log(error);
                      
            });
             };
     
     

    let config = {
      headers: {
         'Authorization': localStorage.getItem("token")
         }
      }

      let config2 = {
        headers: {
           'Authorization': localStorage.getItem("token2")
           }
        }  

        function handlePageChange(value){
          if(value === "&laquo;" || value === '... '){
            setnPag(1);
          }else if (value === "&lsaquo;" ){
            if (nPag !== 1){
              setnPag(nPag -1);
            }
          }else if(value === "&rsaquo;"){
            setnPag(nPag +1);        
          }else if(value === "&raquo;" || value === ' ...' ){
            setnPag(totalPaginas);        
          }else{
            setnPag(value);
          }    
         
         }


      const getDadosRelatorio = async()=>{
        
        let response = {};
        try {
          response = await api.post(vhostV2('webcash/vendas/relsintetico'),{
            loja: localStorage.getItem('loja'),
            empresa: 0,
           //dtinicial:"2023-02-13T13:45:00.000Z",
            dtinicial:dataInical,
            dtfinal:dataFinal,
            tipo:tipo
            
          }, config2)
          
        } catch (error) {
          console.log(error);          
        }
         
        return response.data.dados;
      
        //setItens(response.data.dados); 
        //setResultItens(response.data.result)
        
      
      
      }

           // Aplicando a personalização com opções diferentes
// Abaixo é somente um exemplo de personalização, adapte para o seu projeto
useEffect(() => {
  // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
  customizeScrollbar({
    scrollbarWidth: "10px",
    trackBackground: "#333",
    thumbBackground:
      "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
    thumbBorderRadius: "10px",
  });
}, []);


      async function gerarRelatorio () { 

        const tItens = await getDadosRelatorio();
//          PedidosPdf(tItens);
      //console.log(data)
      // ProductReport();
      
               
      }  


      const toggleState = () => {
        setFiltragem((prevState) => !prevState);
      };

    function filtrarPedidos(){

     
 const sJson = {}

 sJson.loja = localStorage.getItem('loja');
        sJson.empresa = 0;
      
        if(usaDcadastro1 === true)
          { sJson.data_cadastro1=dCadastro1}
          if(usaDAlteracao1 === true)
          { sJson.data_alteracao1=dAlteracao1}
          if(usaDultCompra1 === true)
          { sJson.data_compra1=dultCompra1}
          if(usaDultVenda1 === true)
          { sJson.data_venda1=dultVenda1}
          if(usaDcadastro2 === true)
          { sJson.data_cadastro2=dCadastro2}
          if(usaDAlteracao2 === true)
          { sJson.data_alteracao2=dAlteracao2}
          if(usaDultCompra2 === true)
          { sJson.data_compra2=dultCompra2}
          if(usaDultVenda2 === true)
          { sJson.data_venda2=dultVenda2}
        sJson.tipo = tipo;
        sJson.pagina = nPag;
        sJson.regPag= 10;
        sJson.lancado= "T";
      api.post(vhostV1('webcash/dashboard/listapedidos'),     
        sJson,config)
      .then(function (response) {   
        setPedidos(response.data.dados); 
        
        
        setSresult(response.data.result); 
    
      })
      .catch(function (error) {
        console.log(error);
                
      });
      
       



    } 
    
    
    function formatarData(dataISO) {
      const data = new Date(dataISO);
      const dia = String(data.getUTCDate()).padStart(2, '0');
      const mes = String(data.getUTCMonth() + 1).padStart(2, '0');
      const ano = data.getUTCFullYear();
      
      return `${dia}/${mes}/${ano}`;
  }



   //buscar pedidos
    useEffect(function(){
      const sjson = {}

      if(usaDcadastro1 === true)
        { sjson.dataInicial=dCadastro1}
       
        if(usaDcadastro2 === true)
        { sjson.dataFinal=dCadastro2}
      
      sjson.pagina = nPag;
        sjson.regPag= 10;
        sjson.tipo = tipo;
        sjson.status= 'T';
        console.log(sjson);
         
      api.post(vhostV1('webcash/produto/entradas'),sjson,config)
      .then(function (response) {   
        console.log(response.data);
         setTotalPaginas(response.data.quantidadeDePaginas);    
        setPedidos(response.data.dados); 
        setSresult(response.data.result); 
    
      })
      .catch(function (error) {
        console.log(error);
                
      });
      
      
    },[nPag, filtragem])

 async function getDadosRelatorioAjuste() {
  const sJson = {};

  if (usaDcadastro1 === true) {
    sJson.dataInicial = dCadastro1;
  }

  if (usaDcadastro2 === true) {
    sJson.dataFinal = dCadastro2;
  }
  if( codProduto !== ''){
    sJson.codProduto = codProduto;
  }


  sJson.tipo = tipo;

  console.log(sJson);

  try {
    const response = await api.post(vhostV1('webcash/produto/entradas/relAjuste'), sJson, config);
    console.log(response);

    const dados = response.data.dados;
    setDadosRelatorio(dados); // se precisar exibir em tela ou guardar
    RelAjusteEstoquePDF(dados); // gera o PDF após dados carregarem

  } catch (error) {
    console.error('Erro ao buscar dados do relatório:', error);
  }
}
   
   

    function handleDalteracaocheck(e){
      setusaDalteracao1(e.target.checked);
      setusaDalteracao2(e.target.checked);
    }
        
    function handleDcadastrocheck(e){
      setUsaDcadastro1(e.target.checked);
      setUsaDcadastro2(e.target.checked);
    }
  
    function handleDultCompracheck(e){
      setusaDultcompra1(e.target.checked);
      setusaDultcompra2(e.target.checked);
    }
  
    function handleDultVendacheck(e){
      setusaDultvenda1(e.target.checked);
      setusaDultvenda2(e.target.checked);
    }
      

     useEffect(function(){
        
          api.post(vhostV2('webcash/usuario/listar'), {
              loja: localStorage.getItem('loja'),
              empresa: 0,
              busca: ""
            },config2)
            .then(function (response) {
              console.log(response.data.dados);
              
             
                setColaboradores(response.data.dados); 
                       
            })
            .catch(function (error) {
              console.log(error);
                      
            });
      
            
        },[])

        function closeModalProduto(){
      
      setIsProdutoOpen(false)
   }

   function limparFiltro(){
      setCodProduto('');
      setDescricao('');
      setCompra(0);
      setVendaDefault(0);
      setNcm(0);
      setEstoqueAtual(0);
      setIsProdutoOpen(false);
      setDcadastro1(new Date());
      setDcadastro2(new Date());
      setUsaDcadastro1(false);
      setUsaDcadastro2(false);
      setTipo('T');
      setnPag(1);
      setFiltragem((prevState) => !prevState);
   }

    return <div>

      <ModalProduto
              isOpen={isProdutoOpen}
              onRequestClose={closeModalProduto}
              setCodProduto={setCodProduto}
              setDescricao={setDescricao}
              setVendaDefault={setVendaDefault}
              setNcm={setNcm}
              titulo="pesquisa de Produto"
              setCompra={setCompra}
              setEstoque={setEstoqueAtual}
            />

        <Navbar/>
        <div className="container-fluid titulo offset-lg-2 col-lg-8">
        
        
        <div className="row mb-3">
           <div className="d-flex justify-content-between">
            <h1 className="d-inline">Ajuste de Estoque </h1>
                <div>                
                <Link type="button" className="btn btn-primary btn-cli"  to="/app/estoque/novaentrada/-1"><i className="bi bi-plus-circle-fill"></i> Novo Ajuste</Link>
                <button type="button" className="btn btn-secondary btn-cli" data-bs-toggle="modal" data-bs-target="#moda-filtro"><i className="bi bi-funnel-fill"></i>Filtros</button>
                {/* <button type="button" className="btn btn-danger btn-cli" onClick={getDadosRelatorioAjuste} ><i className="bi bi-printer-fill"></i> Relatório</button> */}
                {/* <SalesReport/> */}
                </div>

                
                
            </div> 
        </div>   
        
        <hr />

        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-sm">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="staticBackdropLabel">Relátorio de Vendas</h1>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <div className="contnt-modal">
                   <h5>Tipo do relatório </h5> 
                  <div className="form-check">
                    <input className="form-check-input" value={0}  type="radio" name="flexRadioDefault" id="flexRadioDefault1"/>
                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                      Sintético
                    </label>
                  </div>
                 

                  <div className="form-check">
                    <input className="form-check-input" value={2}  type="radio" name="flexRadioDefault" id="flexRadioDefault2"/>
                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                      Finalizadora
                    </label>
                  </div>

                    
                    <hr />

                   <div className="row">
                   <div className="datas col-6">
                        <h6>Datas Iniciais</h6>
                          <div className="form-check form-switch" >
                            <input className="form-check-input" onChange={(e) => handleDcadastrocheck(e)} checked={usaDcadastro1} type="checkbox" role="switch"  id="flexSwitchCheckDefault"/>
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Cadastro</label>
                            <input type="date" value={dCadastro1} onChange={(e) => setDcadastro1(e.target.value)} className='form-control' />
                          </div>

                     </div>

                     <div className="datas col-6">
                        <h6 id='data-final-filtro'>Datas Finais</h6>
                          <div className="form-check form-switch mt-4" >
                           
                            <input type="date" value={dCadastro2} onChange={(e) => setDcadastro2(e.target.value)} className='form-control' />
                          </div>

                          
                     </div>
                          
                     </div>

                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                              
                  {/* { sResult === 1?
                  <div>                  
                  <button type="button" onClick={ async()=> await gerarRelatorio()} className="btn btn-primary btn-cli" data-bs-dismiss="modal">Imprimir</button>
                  </div>
                  :null}  */}
                  

                </div>
              </div>
            </div>
          </div>


          <div className="modal fade" id="moda-filtro" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="staticBackdropLabel">Filtros</h1>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <div className="contnt-modal">
                                      
                  

                   <div className="row align-items-end mb-3">

  {/* Tipo */}
  <div className="col-md-12">
    <label className="form-label">Tipo</label>
    <select
      name="status"
      id="status"
      className="form-select"
      onChange={(e) => setTipo(e.target.value)}
    >
      <option value="T">Todos</option>
      <option value="3">ENTRADA</option>
      <option value="4">SAIDA</option>
    </select>
  </div>

  {/* Código */}
  <div className="col-md-12">
    <label htmlFor="inputAddress" className="form-label">Código do Produto</label>
    <div className="input-group">
      <input
        type="text"
        value={codProduto}
        onChange={(e) => setCodProduto(e.target.value)}
        onBlur={() => buscaIten()}
        className="form-control"
        id="inputCod"
        tabIndex="7"
        required
      />
      <button
        type="button"
        id="button-addon2"
        onClick={() => setIsProdutoOpen(true)}
        className="btn btn-primary"
      >
        <i className="bi bi-search"></i>
      </button>
    </div>
  </div>

  <div className="col-12">
              
              <input
                type="text"
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
                onBlur={(e) => buscaIten()}
                className="form-control"
                id="inputDescricao"
                tabIndex="2"
                placeholder='Descrição do Produto'
                autoComplete="off"
                readOnly
              />
            </div>

</div>
                     <br />

                     <div className="row">
                    
                    </div>


                    <div className="row">
                    <div className="datas col-6">
                        <h6>Datas Iniciais</h6>
                          <div className="form-check form-switch ml-2" >
                            <input className="form-check-input" onChange={(e) => handleDcadastrocheck(e)} checked={usaDcadastro1} type="checkbox" role="switch"  id="flexSwitchCheckDefault"/>
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Cadastro</label>
                            <input type="date" value={dCadastro1} onChange={(e) => setDcadastro1(e.target.value)} className='form-control' />
                          </div>

                     </div>

                     <div className="datas col-6">
                        <h6 id='data-final-filtro'>Datas Finais</h6>
                          <div className="form-check form-switch mt-4" >
                           
                            <input type="date" value={dCadastro2} onChange={(e) => setDcadastro2(e.target.value)} className='form-control' />
                          </div>

                         
                     </div>
                     </div>

                  </div>
                </div>
                <div className="modal-footer">
                  <div> 
                    <button type="button" onClick={limparFiltro} className="btn btn-danger btn-cli" data-bs-dismiss="modal">Limpar</button>
                  { codProduto === '' ? <button type="button" onClick={toggleState} className="btn btn-secondary btn-cli" data-bs-dismiss="modal">Ativar</button>: null}                   
                  
                  <button type="button" onClick={getDadosRelatorioAjuste} className="btn btn-success btn-cli" data-bs-dismiss="modal">Imprimir</button>
                  </div>

                  

                </div>
              </div>
            </div>
          </div>

       { sResult === 1?
        <table id='table-estoque' className="table table-hover table-striped mb-5">
            <thead>
            <tr>
            <th scope="col">PEDIDO</th>
                <th scope="col">DATA</th>
                <th scope='col'>COLAB.</th>
                <th scope='col'>TP. AJUSTE</th>
                <th scope="col">VALOR</th>
                <th scope="col">CANC.</th>
                <th scope="col">AÇÃO</th>
                </tr>
            </thead>
            <tbody className="table-group-divider">
            {  
            pedidos.map((pedido) => {
              const colaborador = colaboradores.find(colab => colab.ID === pedido.COD_COLABORADOR);
              const colaboradorDisplay = colaborador ? `${pedido.COD_COLABORADOR} - ${colaborador.NOME}` : pedido.COD_COLABORADOR;

                return <tr key={pedido.ID}>
                       <td>{("0000" + pedido.ID).slice(-6)}</td>
                       <td>{formatarData(pedido.DATA)}</td>
                       <td>{colaboradorDisplay}</td>
                       <td>{pedido.TIPO === '3' ? 'ENTRADA' : pedido.TIPO === '4' ? 'SAÍDA' : pedido.COD_COLABORADOR}</td>
                       <td> R$ {Number(pedido.VALOR).toFixed(2)}</td>
                       <td>{pedido.CANCELADO}</td>
                       
                                             
                       <td><Link to={`/app/estoque/novaentrada/${pedido.ID}`}><i className="bi bi-search"></i></Link></td>

                       </tr>
              } )}  
            </tbody>
          </table>
          :<BuscaVazaia/>} 
     
 
     <div className="row mt-5 mb-5">
            <SRI_pagination totalPage={totalPaginas} 
                            page={nPag} 
                            limit={10} 
                            siblings={1}
                            onPageChange={handlePageChange}/>
            </div>

      </div>     
      <FooterBar/> 
    </div>
}


export default EntradaEstoque;